import { UserInfo, UpdateUserInfoDTO } from '@/services/AuthService.interface'

class AuthDataMapper {
  // return all fields besides email, that cannot be sent in the request
  static buildUpdateUserInfoDTO(updates: Partial<UserInfo>): UpdateUserInfoDTO {
    const updatesClone = { ...updates }
    delete updatesClone.email
    return updatesClone as UpdateUserInfoDTO
  }
}

export default AuthDataMapper
